import React from "react";
import { i18n } from "../../../services/i18nService";
import { FrameIcon, Text } from "../../../services/visualLibraryService";
import { ListStyled, ProfileWrapper, Spacer } from "../../Settings/styles/Styled";

export const Profile = ({ userAccount }) => {
  const userAccountData = {
    [`${i18n.get("pages.settings.profile.firstName")}`]: (userAccount && userAccount.firstName) || "",
    [`${i18n.get("pages.settings.profile.lastName")}`]: (userAccount && userAccount.lastName) || "",
    [`${i18n.get("pages.settings.profile.emailNumber")}`]:
      userAccount && userAccount.emailAddress ? userAccount.emailAddress : userAccount.mobilePhone
  };

  const entries = Object.entries(userAccountData);

  return (
    <>
      <ProfileWrapper>
        <FrameIcon name="profile" />
        <Text rank="1" text={i18n.get(`pages.settings.menu.profile`)} size="xmedium" />
      </ProfileWrapper>
      <Spacer />
      {entries.map(name => (
        <ListStyled key={name[0]}>
          <Text size="small" text={name[0]} rank="1" />
          <Text className="keyHeading" size="xmedium" text={name[1]} rank="2" />
        </ListStyled>
      ))}
    </>
  );
};
